const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Screenvga = () => import("@/views/screenvga");
const ScreenvgaDetail = () => import("@/views/screenvga/detail");


export default [
    {
        path: "/screenvga",
        name: "screenvga",
        component: Main,
        meta: {
            name: "屏幕分辨率设置",
            unfold: false, //是否可以被展开
            iconType: "desktop"
        },
        redirect: {
            name: "screenvgaList"
        },
        children: [
            {
                path: "",
                name: "screenvgaList",
                component: Screenvga,
                meta: {
                    name: "屏幕分辨率设置",
                    role:{}
                },
                children: [
                    {
                        path: "/add",
                        name: "screenvgaAdd",
                        component: ScreenvgaDetail,
                        meta: {
                            name: "新增分辨率",
                            role:{}
                        }
                    },
                    {
                        path: "/edit",
                        name: "screenvgaEdit",
                        component: ScreenvgaDetail,
                        meta: {
                            name: "编辑分辨率",
                            role:{}
                        }
                    }
                ]
            }
        ]
    }
];